// src/components/CamPreview.tsx
// Live-Vorschau der gewählten Webcam auf dem Geräte-Screen (Pre-Join, Sprecher + Gast). Hält den Stream
// nur solange gemountet; Cleanup stoppt ihn → gibt die Kamera frei, bevor der echte Publish sie greift.
import { useEffect, useRef } from 'react';

export function CamPreview({ deviceId }: { deviceId: string }) {
  const ref = useRef<HTMLVideoElement | null>(null);
  useEffect(() => {
    let stream: MediaStream | null = null;
    let cancelled = false;
    navigator.mediaDevices
      .getUserMedia({ video: deviceId ? { deviceId: { exact: deviceId } } : true })
      .then((s) => {
        if (cancelled) { s.getTracks().forEach((t) => t.stop()); return; }
        stream = s;
        const v = ref.current;
        if (v) { v.srcObject = s; v.muted = true; void v.play().catch(() => { /* autoplay-gate */ }); }
      })
      .catch(() => { /* keine Kamera / verweigert → kein Preview */ });
    return () => { cancelled = true; stream?.getTracks().forEach((t) => t.stop()); };
  }, [deviceId]);
  return <video ref={ref} playsInline muted style={{ width: 160, height: 90, background: '#000', borderRadius: 4 }} />;
}
